import { addDoc, collection, getFirestore } from 'firebase/firestore';

export default function createProcessLog(logData) {
  return addDoc(collection(getFirestore(), 'process_logs'), logData);
}
